/**
 * @flow
 *
 * @format
 */
import BaseItem, { ItemTypes } from './BaseItem';

/* ***************************
  CLASS
*************************** */
export type AppSuccess = {};

export default class SuccessItem extends BaseItem {
  constructor(json: any) {
    if (json instanceof SuccessItem) {
      super(json, true);
    } else {
      super(json, false);
    }
    const { type, meta, ...newMeta } = json;
    this.type = ItemTypes.Success;
    this.setMeta({ ...json.meta, ...newMeta });
  }
}
